import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [zones, setZones] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [grupoIncentivos, setGrupoIncentivos] = useState([]);
  const [canal, setCanal] = useState([]);
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }
  async function listBureaus() {
    let response = await wsFindBy('sale/portafolio-bureau', { base_zone_id: dataChanging.base_zone_id, base_business_partner_id: 1});
    if (response.success) setBureaus(response.data);
  }
  async function listSeller() {
    let response = await wsFindBy('sale/portafolio-bureau-seller', {base_bureau_id: dataChanging.base_bureau_id, base_business_partner_id: 1});
    if (response.success) setSellers(response.data);
  }
  async function listGrupoIncentivo() {
    let response = await wsGetAll('sale/grupo-incentivo');
    if (response.success) setGrupoIncentivos(response.data);
  }
  async function listCanales() {
    let response = await wsGetAll('sale/canal-incentivo');
    if (response.success) setCanal(response.data);
  }
  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            base_zone_code: item.ZONAL,
            base_bureau_code: item.MESA,
            unilever_grupo_code: item.GRUPO,
            SlpCode: item.VENDEDOR,
            base_canal_description: item.CANAL.charAt(0).toUpperCase() + item.CANAL.slice(1).toLowerCase(),
            importe: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_zone_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: bPartnerSelect?.base_zone_id || '',
      }));
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) {listZones();listGrupoIncentivo();listCanales();};
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (dataChanging.base_zone_id) {
      setDataChanging(prev => ({
        ...prev,
        base_bureau_id: null,
        base_seller_id: null,
      }));
      setBureaus([]);
      setSellers([]);
      listBureaus();
    }
  }, [dataChanging.base_zone_id]);
  useEffect(() => {
    if (dataChanging.base_bureau_id) {
      setDataChanging(prev => ({
        ...prev,
        base_seller_id: null,
      }));
      setSellers([]);
      listSeller();
    }
  }, [dataChanging.base_bureau_id]);

  return (
    <>
      <Modal
        title={`Nueva cuota de vendedor`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.base_zone_id
            ? 'sale/cuota-vendedor'
            : 'sale/cuota-vendedor/multiple'
        }
        dataForce={
          dataChanging.base_zone_id
            ? {
              base_zone_id: dataChanging.base_zone_id,
              base_bureau_id: dataChanging.base_bureau_id,
              base_seller_id: dataChanging.base_seller_id,
              unilever_grupo_id: dataChanging.unilever_grupo_id,
              }
            : {
                base_zone_id: cuota.valueSearch?.base_zone_id,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description} (Código: ${item.code})`}
            renderInput={(params) => (
              <TextField {...params} label="Zonas" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_zone_id', item?.id); setDataImport(null);}}
            value={zones.find((zone) => zone.id === dataChanging.base_zone_id) || null}
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['VENDEDOR', 'GRUPO']}
            sortDuplicate={['VENDEDOR', 'GRUPO']}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.periodo).format('YYYY-MM')}_Plantilla de cuota para vendedor`,
              fields: ['ZONAL','MESA','GRUPO','VENDEDOR','CANAL','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.base_zone_id ? (
          <>
            <Autocomplete
              disableClearable
              options={bureaus}
              getOptionLabel={(item) => `${item.description}`}
              renderInput={(params) => (
                <TextField {...params} label="Mesas" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_bureau_id', item?.base_bureau_id); setDataImport(null);}}
              value={bureaus.find((bureau) => bureau.base_bureau_id === dataChanging.base_bureau_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
              disabled={!bureaus.length}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Canal</InputLabel>
              <Select
                required
                value={dataChanging.base_canal_id || ''}
                inputProps={{
                  name: 'base_canal_id',
                  onChange: (e) => handleChange('base_canal_id', e.target.value),
                }}
              >
                {canal.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Autocomplete
              disableClearable
              options={sellers}
              getOptionLabel={(item) => `${item.SlpName})`}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_seller_id', item?.base_seller_id); setDataImport(null);}}
              value={sellers.find((seller) => seller.base_seller_id === dataChanging.base_seller_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
              disabled={!sellers.length}
            />
            <Autocomplete
              disableClearable
              options={grupoIncentivos}
              getOptionLabel={(item) => `${item.description} - ${item.tipo_incentivo}`}
              renderInput={(params) => (
                <TextField {...params} label="Grupo incentivo" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('unilever_grupo_id', item?.id); setDataImport(null);}}
              value={grupoIncentivos.find((grupo) => grupo.id === dataChanging.unilever_grupo_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <TextField
              label="Importe"
              fullWidth
              type="number"
              name="importe"
              margin="normal"
              value={dataChanging.importe || ''}
              onChange={(e) => handleChange('importe', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
